import React from 'react';
import PrevImg from '../components/images/Previous.svg';
import NextImg from '../components/images/Next.svg';

export default (props) => {
	const {
		      showPrevLink,
		      showNextLink,
		      handlePrevClick,
		      handleNextClick,
		      loading,
              show_start,
              show_end,
              total,
              type,
              currentPage,
              totalPages
	      } = props;
	return (
        <div>
            <div className="advanced_pagination">
                <h4 className="tabulation">{show_start} to {(show_end > total) ? total : show_end} OF {total} {type}</h4>
            </div>
            <div className="nav-link-container">
                {currentPage >= 1 ?
                    <button onClick={handlePrevClick} id="prev_button" className={`nav-link ${ showPrevLink ? 'show' : 'hide'}${ loading ? 'greyed-out' : '' }`}>
                        <img className="pagination_arrow" src={PrevImg} />PREVIOUS
                    </button>
                : ''}
                {totalPages > 1 ?
                    <button onClick={handleNextClick} id="next_button" className={`nav-link ${showNextLink ? 'show' : 'hide'}${ loading ? 'greyed-out' : '' }`}>
                        NEXT<img className="pagination_arrow" src={NextImg} />
                    </button>
                : ''}
            </div>
        </div>
	);
};